if (!customElements.get("store-locator")) {
  class StoreLocator extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.filters = ['available', 'company_operated', 'store'];
      this.results = this.querySelectorAll(".stocklist__result");
      this.loading = this.querySelector(".stocklist__loader");
      this.markers = [];
      this.displayedSalon = [];
      this.markerClusterers = null;
      this.infoWindow = null;
      this.filterCheckBoxs = this.querySelectorAll('input[name="filters"]');
    }
    connectedCallback() {
      this._submitListener = this.submit.bind(this);
      this._filterSalonListener = this.filterSalon.bind(this);
      this.form.addEventListener("submit", this._submitListener);
      this.filterCheckBoxs.forEach((checkbox) => {
        checkbox.addEventListener("change", this._filterSalonListener);
      });

      const url = this.dataset.salons;
      $.getJSON(url, (data) => {
        this.salonList = data;
        window.initMap = this.initMap.bind(this);
        this.initMap();
      });
    }
    disconnectedCallback() {
      this.form.removeEventListener("submit", this._submitListener);
      this.filterCheckBoxs.forEach((checkbox) => {
        checkbox.removeEventListener("change", this._filterSalonListener);
      });
    }
    initMap() {
      if (JMO.customer) {
        const currentAddress = JMO.customer.defaultAddress;

        if (currentAddress) {
          const address = `${currentAddress.address1}${currentAddress.address2}, ${currentAddress.city}, ${currentAddress.province}, ${currentAddress.country}`;
          this._doGeocode(address, (results) => {
            for (let i = 0; i < results.length; i++) {
              const place = results[i];
    
              if (place.geometry.location) {
                this.initMapWithCurrentLocation(place.geometry.location);
              } else {
                this.initMapWithoutCurrentLocation();
              }
            }
          });
        }
      } else {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const currentLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              this.initMapWithCurrentLocation(currentLocation);
            },
            async (positionError) => {
              this.initMapWithoutCurrentLocation();
            }
          );
        }
      }
    }
    initMapWithCurrentLocation(location) {
      this.map = new google.maps.Map(
        document.getElementById("stocklist__map"),
        {
          center: location,
          zoom: 12,
          mapTypeControl: false,
          styles: [
            {
              featureType: "all",
              elementType: "geometry.fill",
              stylers: [
                {
                  weight: "2.00",
                },
              ],
            },
            {
              featureType: "all",
              elementType: "geometry.stroke",
              stylers: [
                {
                  color: "#9c9c9c",
                },
              ],
            },
            {
              featureType: "all",
              elementType: "labels.text",
              stylers: [
                {
                  visibility: "on",
                },
              ],
            },
            {
              featureType: "landscape",
              elementType: "all",
              stylers: [
                {
                  color: "#f2f2f2",
                },
              ],
            },
            {
              featureType: "landscape",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#ffffff",
                },
              ],
            },
            {
              featureType: "landscape.man_made",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#ffffff",
                },
              ],
            },
            {
              featureType: "poi",
              elementType: "all",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "all",
              stylers: [
                {
                  saturation: -100,
                },
                {
                  lightness: 45,
                },
              ],
            },
            {
              featureType: "road",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#eeeeee",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#7b7b7b",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "labels.text.stroke",
              stylers: [
                {
                  color: "#ffffff",
                },
              ],
            },
            {
              featureType: "road.highway",
              elementType: "all",
              stylers: [
                {
                  visibility: "simplified",
                },
              ],
            },
            {
              featureType: "road.arterial",
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "transit",
              elementType: "all",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "water",
              elementType: "all",
              stylers: [
                {
                  color: "#46bcec",
                },
                {
                  visibility: "on",
                },
              ],
            },
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#c8d7d4",
                },
              ],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#070707",
                },
              ],
            },
            {
              featureType: "water",
              elementType: "labels.text.stroke",
              stylers: [
                {
                  color: "#ffffff",
                },
              ],
            },
          ],
        }
      );

      this.infoWindow = new google.maps.InfoWindow({ maxWidth: 300 });

      //#region autocomplete search
      const input = document.getElementById("pac-input");

      const options = {
        types: ["(regions)"],
        fields: ["formatted_address", "geometry", "name"],
        strictBounds: false,
        componentRestrictions: {
          country: "JP",
        },
      };
      const autocomplete = new google.maps.places.Autocomplete(input, options);

      // Bind the map's bounds (viewport) property to the autocomplete object,
      // so that the autocomplete requests use the current map bounds for the
      // bounds option in the request.
      autocomplete.bindTo("bounds", this.map);

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        // If the place has a geometry, then present it on a map.
        // if (place.geometry.viewport) {
        //   this.map.fitBounds(place.geometry.viewport);
        // } else {
        this.map.setCenter(place.geometry.location);
        // }
      });
      //#endregion

      //! get all markers in viewport
      // Add event listeners for when the map has changed: drag, zoom in/out or page refreshed.
      this._showMarkersInViewportListener =
        this.showMarkersInViewport.bind(this);
      google.maps.event.addListener(
        this.map,
        "dragend",
        this._showMarkersInViewportListener
      );
      google.maps.event.addListenerOnce(
        this.map,
        "idle",
        this._showMarkersInViewportListener
      );
      //! end get all markers in viewport
    }
    async initMapWithoutCurrentLocation() {
      const jpGeometry = {
        bounds: {
          northeast: {
            lat: 45.6412626,
            lng: 154.0031455,
          },
          southwest: {
            lat: 20.3585295,
            lng: 122.8554688,
          },
        },
        location: {
          lat: 36.204824,
          lng: 138.252924,
        },
        location_type: "APPROXIMATE",
        viewport: {
          northeast: {
            lat: 47.23074,
            lng: 155.0957938,
          },
          southwest: {
            lat: 19.7696372,
            lng: 119.2119354,
          },
        },
      };

      const tokyoGeometry = {
        bounds: {
          northeast: {
            lat: 35.6645242,
            lng: 139.686951,
          },
          southwest: {
            lat: 35.648436,
            lng: 139.673304,
          },
        },
        location: {
          lat: 35.6668951,
          lng: 139.6720164,
        },
        location_type: "APPROXIMATE",
        viewport: {
          northeast: {
            lat: 35.698303,
            lng: 139.738192,
          },
          southwest: {
            lat: 35.634499,
            lng: 139.632277,
          },
        },
      };

      const { LatLngBounds } = await google.maps.importLibrary("core");
      const viewport = new LatLngBounds(
        new google.maps.LatLng(
          tokyoGeometry.viewport.southwest.lat,
          tokyoGeometry.viewport.southwest.lng
        ),
        new google.maps.LatLng(
          tokyoGeometry.viewport.northeast.lat,
          tokyoGeometry.viewport.northeast.lng
        )
      );

      this.map = new google.maps.Map(
        document.getElementById("stocklist__map"),
        {
          center: tokyoGeometry.location,
          zoom: 12,
          mapTypeControl: false,
          styles: [
            {
              featureType: "all",
              elementType: "geometry.fill",
              stylers: [
                {
                  weight: "2.00",
                },
              ],
            },
            {
              featureType: "all",
              elementType: "geometry.stroke",
              stylers: [
                {
                  color: "#9c9c9c",
                },
              ],
            },
            {
              featureType: "all",
              elementType: "labels.text",
              stylers: [
                {
                  visibility: "on",
                },
              ],
            },
            {
              featureType: "landscape",
              elementType: "all",
              stylers: [
                {
                  color: "#f2f2f2",
                },
              ],
            },
            {
              featureType: "landscape",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#ffffff",
                },
              ],
            },
            {
              featureType: "landscape.man_made",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#ffffff",
                },
              ],
            },
            {
              featureType: "poi",
              elementType: "all",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "all",
              stylers: [
                {
                  saturation: -100,
                },
                {
                  lightness: 45,
                },
              ],
            },
            {
              featureType: "road",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#eeeeee",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#7b7b7b",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "labels.text.stroke",
              stylers: [
                {
                  color: "#ffffff",
                },
              ],
            },
            {
              featureType: "road.highway",
              elementType: "all",
              stylers: [
                {
                  visibility: "simplified",
                },
              ],
            },
            {
              featureType: "road.arterial",
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "transit",
              elementType: "all",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "water",
              elementType: "all",
              stylers: [
                {
                  color: "#46bcec",
                },
                {
                  visibility: "on",
                },
              ],
            },
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#c8d7d4",
                },
              ],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#070707",
                },
              ],
            },
            {
              featureType: "water",
              elementType: "labels.text.stroke",
              stylers: [
                {
                  color: "#ffffff",
                },
              ],
            },
          ],
        }
      );

      this.map.fitBounds(viewport);

      this.infoWindow = new google.maps.InfoWindow({ maxWidth: 300 });

      //#region autocomplete search
      const input = document.getElementById("pac-input");

      const options = {
        types: ["(regions)"],
        fields: ["formatted_address", "geometry", "name"],
        strictBounds: false,
        componentRestrictions: {
          country: "JP",
        },
      };
      const autocomplete = new google.maps.places.Autocomplete(input, options);

      // Bind the map's bounds (viewport) property to the autocomplete object,
      // so that the autocomplete requests use the current map bounds for the
      // bounds option in the request.
      autocomplete.bindTo("bounds", this.map);

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        // If the place has a geometry, then present it on a map.
        // if (place.geometry.viewport) {
        //   this.map.fitBounds(place.geometry.viewport);
        // } else {
        this.map.setCenter(place.geometry.location);
        // }
      });
      //#endregion

      //! get all markers in viewport
      // Add event listeners for when the map has changed: drag, zoom in/out or page refreshed.
      this._showMarkersInViewportListener =
        this.showMarkersInViewport.bind(this);
      google.maps.event.addListener(
        this.map,
        "dragend",
        this._showMarkersInViewportListener
      );
      google.maps.event.addListenerOnce(
        this.map,
        "idle",
        this._showMarkersInViewportListener
      );
      //! end get all markers in viewport
    }
    filterSalon(event) {
      if (event.target.checked) {
        this.filters.push(event.target.value);
      } else {
        this.filters = this.filters.filter(
          (filter) => filter !== event.target.value
        );
      }

      this.showMarkersInViewport();
    }
    async showMarkersInViewport() {
      if (Array.isArray(this.salonList)) {
        this.showLoading();

        const { spherical } = await google.maps.importLibrary("geometry");
        const bounds = this.map.getBounds();

        this.displayedSalon = this.salonList
          .filter((salon) => {
            if (this.filterByType(salon)) {
              const location = new google.maps.LatLng(
                salon.latitude,
                salon.longitude
              );

              if (bounds && bounds.contains(location)) {
                return true;
              }

              const distance =
                spherical.computeDistanceBetween(
                  this.map.getCenter(),
                  location
                ) / 1000;

              if (distance <= 25) {
                return true;
              }
            }

            return false;
          })
          .sort((a, b) => {
            const locationA = new google.maps.LatLng(a.latitude, a.longitude);
            const locationB = new google.maps.LatLng(b.latitude, b.longitude);
            const distanceA =
              spherical.computeDistanceBetween(
                this.map.getCenter(),
                locationA
              ) / 1000;
            const distanceB =
              spherical.computeDistanceBetween(
                this.map.getCenter(),
                locationB
              ) / 1000;

            return distanceB - distanceA;
          });
        // .slice(0, 100);

        await new Promise((resolve) => setTimeout(resolve, 100));

        this.hideLoading();
        this.removeMarkers();
        this.addMarkers();
      }
    }
    filterByType(salon) {
      if (!this.filters || this.filters.length === 0) {
        return false;
      }

      return this.filters.some((type) => salon[type] === "Yes");
    }
    getType(salon) {
      if (!salon) {
        return null;
      }

      return Object.keys(salon).find((key) => salon[key] === "Yes");
    }
    async submit(event) {
      event.preventDefault();
      const formData = new FormData(this.form);
      const keyword = formData.get("keyword");
      const filters = formData.getAll("filters");
      this.filters = filters;

      this._doGeocode(keyword, (results) => {
        for (let i = 0; i < results.length; i++) {
          const place = results[i];

          // If the place has a geometry, then present it on a map.
          if (place.geometry.viewport) {
            this.map.fitBounds(place.geometry.viewport);
            // this.map.setZoom(12)
          } else {
            this.map.setCenter(place.geometry.location);
            // this.map.setZoom(12)
          }

          this.showMarkersInViewport();
        }
      });
    }
    async addMarkers() {
      if (this.results != null && this.results.length !== 0) {
        this.results.forEach((result) => {
          const resultList = result.querySelector(".stocklist__result-list");
          resultList.innerHTML = "";
        });
      }

      if (this.displayedSalon.length !== 0) {
        this.displayedSalon.forEach((salon) => {

          const iconMap = {
            available: '/cdn/shop/t/496/assets/ico_shopping.svg',
            company_operated: '/cdn/shop/t/496/assets/ico_product.svg',
            store: '/cdn/shop/t/496/assets/ico_counseling.svg',
          };

          let icon = 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'; // デフォルト値

          if (salon.available === 'Yes') {
            icon = iconMap.available;
          } else if (salon.company_operated === 'Yes') {
            icon = iconMap.company_operated;
          } else if (salon.store === 'Yes') {
            icon = iconMap.store;
          }
          
          let currentMarker = this.getCurrentMarker(salon);

          const li = document.createElement("li");
          li.classList.add("stocklist__result-item");
          li.innerHTML = this.getContentResultItem(salon);

          if (!currentMarker) {
            const location = new google.maps.LatLng(
              salon.latitude,
              salon.longitude
            );
            const type = this.getType(salon);
            currentMarker = new google.maps.Marker({
              position: location,
              map: this.map,
              title: salon.salon_name,
              draggable: true,
              icon: type ? {
                url: `${ICON[type]}&height=37&width=26`,
              } : null
            });

            this.markers.push(currentMarker);
            currentMarker.addListener("click", () => {
              this.infoWindow.setContent(this.getContentInfoWindow(salon));
              this.infoWindow.open(this.map, currentMarker);
            });
          }

          if (this.results != null && this.results.length !== 0) {
            this.results.forEach((result, index) => {
              const resultList = result.querySelector(
                ".stocklist__result-list"
              );
              let _li = li.cloneNode(true);

              _li.addEventListener("click", () => {
                this.selectedItem(_li);
                this.infoWindow.setContent(this.getContentInfoWindow(salon));
                this.infoWindow.open(this.map, currentMarker);
              });
              resultList.insertBefore(_li, resultList.firstChild);
            });
          }
        });

        // Add a marker clusterer to manage the markers.
        const icon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14.8167mm" height="11.6417mm" version="1.2" baseProfile="tiny">
        <desc>Created by EvoPdf</desc>
        <defs>
        </defs>
        <g fill="none" stroke="black" stroke-width="1" fill-rule="evenodd" stroke-linecap="square" stroke-linejoin="bevel">
        
        <g fill="#000000" fill-opacity="1" stroke="#000000" stroke-opacity="1" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter" stroke-miterlimit="2" transform="matrix(1,0,0,1,0,0)">
        </g>
        
        <g fill="#000000" fill-opacity="1" stroke="#000000" stroke-opacity="1" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter" stroke-miterlimit="2" transform="matrix(1,0,0,1,0,0)">
        </g>
        
        <g fill="#000000" fill-opacity="1" stroke="#000000" stroke-opacity="1" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter" stroke-miterlimit="2" transform="matrix(1,0,0,1,0,0)">
        </g>
        
        <g fill="#000000" fill-opacity="1" stroke="#000000" stroke-opacity="1" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter" stroke-miterlimit="2" transform="matrix(1,0,0,1,0,0)">
        </g>
        
        <g fill="#000000" fill-opacity="1" stroke="#000000" stroke-opacity="1" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter" stroke-miterlimit="2" transform="matrix(1,0,0,1,0,0)">
        </g>
        
        <g fill="#000000" fill-opacity="1" stroke="#000000" stroke-opacity="1" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter" stroke-miterlimit="2" transform="matrix(1,0,0,1,0,0)">
        </g>
        </g>
        </svg>`;
        
        this.markerClusterers = new markerClusterer.MarkerClusterer({
          markers: this.markers,
          map: this.map,
          renderer: {
            render: ({ count, position }) => {
              return new google.maps.Marker({
                position: {
                  lat: position.lat(),
                  lng: position.lng(),
                },
                label: {
                  text: count.toString(),
                  color: "#ffffff",
                  fontSize: "12px",
                  fontWeight: "bold",
                  className: "stocklist__cluster-icon",
                  zIndex: -1,
                },
                icon: icon,
                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
              });
            },
          },
        });
      }
      //! end add markers
    }
    getCurrentMarker(location) {
      const _location = new google.maps.LatLng(
        location.latitude,
        location.longitude
      );

      return this.markers.find((marker) =>
        marker.getPosition().equals(_location)
      );
    }
    getContentResultItem(salon) {
      const type = this.getType(salon);

      return `
        <div class="result__item-distance">
          <span class="stocklist__icon stocklist__marker-icon" aria-hidden="true">
            <img 
              src="${ICON[type]}"
              loading="lazy"
              alt=""
              class=""
            >
          </span>
        </div>
        <div class="result__item-name">${salon.salon_name}</div>
        <div class="result__item-address">${salon.address}</div>
        <div class="result__item-filters">
          <div class="result__item-filter">
            ${salon.available === "Yes" ? "サロン" : ""}
            ${salon.company_operated === "Yes" ? "直営店" : ""}
            ${salon.store === "Yes" ? "販売店" : ""}
          </div>
        </div>
        ${
          salon.opening_hours !== ""
            ? `<div class="result__item-custom-fields">
          <div class="result__item-custom-field">
            <span>
              営業時間 等:
            </span>
            ${salon.opening_hours}
          </div>
        </div>`
            : ""
        }
        <div class="result__item-details">
          <div class="result__item-phone">${salon.phone}</div>
          ${
            salon.website !== ""
              ? `<div class="result__item-website">
              <a href="${salon.website}" target="_blank">
                ${salon.website}
              </a>
            </div>`
              : ""
          }
        </div>
        <div class="result__item-directions-link"></div><!--todo: directions-link-->`;
    }
    getContentInfoWindow(salon) {
      return `
        <div class="stocklist__result-item stocklist__result-item--infowindow">
          <div class="result__item-name">${salon.salon_name}</div>
          <div class="result__item-address">${salon.address}</div>
          <div class="result__item-filters">
            <div class="result__item-filter">
              ${salon.available === "Yes" ? "サロン" : ""}
              ${salon.company_operated === "Yes" ? "直営店" : ""}
              ${salon.store === "Yes" ? "販売店" : ""}
            </div>
          </div>
          ${
            salon.opening_hours !== ""
              ? `<div class="result__item-custom-fields">
            <div class="result__item-custom-field">
              <span>
                Opening Hours:
              </span>
              ${salon.opening_hours}
            </div>
          </div>`
              : ""
          }
          <div class="result__item-details">
            <div class="result__item-phone">${salon.phone}</div>
            ${
              salon.website !== ""
                ? `<div class="result__item-website">
              <a href="${salon.website}" target="_blank">
                ${salon.website}
              </a>
            </div>`
                : ""
            }
          </div>
          <div class="result__item-directions-link">
            <a href="https://www.google.com/maps/dir/?api=1&destination=${
              salon.latitude
            },${salon.longitude}" target="_blank">
              行き方
            </a>
          </div>
        </div>`;
    }
    removeMarkers() {
      const markers = this.markers.map((marker) => {
        let isFreeMarker = false;

        if (this.displayedSalon.length === 0) {
          isFreeMarker = true;
        } else {
          isFreeMarker = this.displayedSalon.every((salon) => {
            const _location = new google.maps.LatLng(
              salon.latitude,
              salon.longitude
            );

            return !marker.getPosition().equals(_location);
          });
        }

        if (isFreeMarker) {
          marker.setMap(null);
        } else {
          return marker;
        }
      });

      if (this.markerClusterers != null) {
        this.markerClusterers.removeMarkers(this.markers);
      }

      this.markers = markers.filter(Boolean);
    }
    async _doGeocode(address, callback = null, fallback = null) {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        {
          address: address,
          componentRestrictions: {
            country: "JP",
          },
        },
        (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            callback && callback(results);
          } else {
            //Error handling
            console.log(
              "Geocode was not successful for the following reason: " + status
            );
            fallback && fallback(results);
          }
        }
      );
    }
    selectedItem(li) {
      if (this.results != null && this.results.length !== 0) {
        this.results.forEach((result) => {
          const resultItems = result.querySelectorAll(
            ".stocklist__result-item"
          );
          resultItems.forEach((item) => {
            item.classList.remove("stocklist__result-item--selected");
          });
          li.classList.add("stocklist__result-item--selected");
        });
      }
    }
    showLoading() {
      if (this.loading) {
        this.loading.classList.add("show");
      }
      if (this.results != null && this.results.length !== 0) {
        this.results.forEach((result) => {
          const resultMessage = result.querySelector(
            ".stocklist__result-message"
          );
          const resultList = result.querySelector(".stocklist__result-list");

          if (resultMessage) {
            resultMessage.classList.remove("show");
          }
          if (resultList) {
            resultList.classList.remove("show");
          }
        });
      }
    }
    hideLoading() {
      if (this.loading) {
        this.loading.classList.remove("show");
      }
      if (this.results != null && this.results.length !== 0) {
        this.results.forEach((result) => {
          const resultMessage = result.querySelector(
            ".stocklist__result-message"
          );
          const resultList = result.querySelector(".stocklist__result-list");

          if (this.displayedSalon.length !== 0) {
            if (resultMessage) {
              resultMessage.classList.remove("show");
            }
            if (resultList) {
              resultList.classList.add("show");
            }
          } else {
            if (resultMessage) {
              resultMessage.classList.add("show");
            }
            if (resultList) {
              resultList.classList.remove("show");
            }
          }
        });
      }
    }
  }

  customElements.define("store-locator", StoreLocator);
}
